export default __webpack_public_path__ + "static/media/long12.a510b778.jpg";